var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("基本信息")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活动名称",
                        "label-col": { span: 2 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["fissionName", _vm.rules.fissionName],
                            expression: "['fissionName',rules.fissionName]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活动时间",
                        "label-col": { span: 2 },
                        "wrapper-col": { span: 8 },
                      },
                    },
                    [
                      _c("a-range-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["fissionTime", _vm.rules.fissionTime],
                            expression: "['fissionTime',rules.fissionTime]",
                          },
                        ],
                        attrs: {
                          "show-time": "",
                          valueFormat: "YYYY-MM-DD HH:mm:ss",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("兑奖设置")]),
          _c("roleTable", { ref: "roleTable" }),
          _c("div", { staticClass: "form_title" }, [_vm._v("裂变文案")]),
          _c(
            "div",
            { staticClass: "text_editer" },
            [
              _c(
                "div",
                [
                  _c("span", [_vm._v("添加变量：")]),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.insert("@「员工名称」", 0)
                        },
                      },
                    },
                    [_vm._v("员工名称")]
                  ),
                ],
                1
              ),
              _c("chatInput", {
                ref: "chatInput",
                staticClass: "chatInput",
                model: {
                  value: _vm.fissionContent,
                  callback: function ($$v) {
                    _vm.fissionContent = $$v
                  },
                  expression: "fissionContent",
                },
              }),
              _c("div", [
                _vm._v("新用户添加裂变成员时自动发送此文案和裂变海报"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("结束文案")]),
          _c(
            "div",
            { staticClass: "text_editer" },
            [
              _c("chatInput", {
                ref: "chatInput2",
                staticClass: "chatInput",
                model: {
                  value: _vm.fissionEndContent,
                  callback: function ($$v) {
                    _vm.fissionEndContent = $$v
                  },
                  expression: "fissionEndContent",
                },
              }),
              _c("div", [
                _vm._v(
                  "活动结束后3天内，新用户通过活动添加裂变员工时自动发送此文案"
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("助力限制")]),
          _c(
            "div",
            [
              _c("a-switch", {
                staticStyle: { margin: "-8px 10px 0" },
                attrs: {
                  "checked-children": "是",
                  "un-checked-children": "否",
                },
                model: {
                  value: _vm.isNewAssist,
                  callback: function ($$v) {
                    _vm.isNewAssist = $$v
                  },
                  expression: "isNewAssist",
                },
              }),
              _c("h3", { staticStyle: { display: "inline-block" } }, [
                _vm._v("新客户才能助力"),
              ]),
              _vm._v(
                " （若客户在活动前已添加过企业任意员工，该客户将不被计入助力次数） "
              ),
            ],
            1
          ),
          _c("div", [_vm._v("欢迎语文案设置：")]),
          _c(
            "div",
            { staticClass: "text_editer" },
            [
              _c(
                "div",
                [
                  _c("span", [_vm._v("添加变量：")]),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isNewAssist,
                          expression: "isNewAssist",
                        },
                      ],
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.insert("@「员工名称」", 2)
                        },
                      },
                    },
                    [_vm._v("员工名称")]
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isNewAssist,
                          expression: "!isNewAssist",
                        },
                      ],
                      attrs: { type: "link" },
                    },
                    [_vm._v("员工名称")]
                  ),
                ],
                1
              ),
              _c("chatInput", {
                ref: "chatInput1",
                staticClass: "chatInput",
                attrs: { editable: _vm.isNewAssist },
                model: {
                  value: _vm.fissionNewContent,
                  callback: function ($$v) {
                    _vm.fissionNewContent = $$v
                  },
                  expression: "fissionNewContent",
                },
              }),
              _c("div", [
                _vm._v("新用户添加裂变成员时自动发送此文案和裂变海报"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("分享信息")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "分享标题",
                        "label-col": { span: 2 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["shareTitle", _vm.rules.shareTitle],
                            expression: "['shareTitle',rules.shareTitle]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "分享文案",
                        "label-col": { span: 2 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["shareDescribe", _vm.rules.shareDescribe],
                            expression: "['shareDescribe',rules.shareDescribe]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "分享图片",
                        "label-col": { span: 2 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("uploader", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["shareImg", _vm.rules.shareImg],
                            expression: "['shareImg',rules.shareImg]",
                          },
                        ],
                        attrs: {
                          num: 1,
                          accept: "image/*",
                          url: _vm.api.temp.UPLOAD_PATH,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c("a-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("下一步")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }